import { RouteRecordRaw } from 'vue-router';

import { $i } from '@silae/composables';
import { defaultLayoutComponents } from '~/_v3/common/ui/components/layout/layout';
import { RouteKeys } from '~/router/routes.domain.ts';

export const TrashRoute: RouteRecordRaw = {
	name: RouteKeys.TRASH,
	path: '/trash',
	alias: '',
	components: {
		default: () => import('~/_v3/trash/ui/pages/TrashPage.vue'),
		...defaultLayoutComponents
	},
	meta: {
		label: 'trash.navigation',
		icon: () => $i('trash'),
		isNavEntry: true,
		order: 1,
		requiresAuth: true
	}
};
